import { render, staticRenderFns } from "./AppointmentNotesDialog.vue?vue&type=template&id=6b00bfd0&scoped=true&"
import script from "./AppointmentNotesDialog.vue?vue&type=script&lang=js&"
export * from "./AppointmentNotesDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentNotesDialog.vue?vue&type=style&index=0&id=6b00bfd0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b00bfd0",
  null
  
)

export default component.exports